/* eslint-disable import/no-unresolved */
import { css } from 'styled-components';
import { FROM_TABLET, MOBILE, TABLET } from 'helpers/styles/media';

export const Variables = css`
  --main-font: 'Tajawal';
  --primary-color-1: #333333;
  --primary-color-2: #4f4f4f;
  --primary-color-3: #828282;
  --primary-color-4: #bdbdbd;
  --primary-color-5: #e0e0e0;
  --primary-color-6: #f2f2f2;
`;

export const H1Styles = css`
  font-weight: 700;
  font-size: 46px;
  line-height: 62px;

  @media ${TABLET} {
    font-size: 38px;
    line-height: 48px;
  }

  @media ${MOBILE} {
    font-size: 25px;
    line-height: 30px;
  }
`;

export const H2Styles = css`
  font-weight: 700;
  font-size: 36px;
  line-height: 48px;

  @media ${TABLET} {
    font-size: 32px;
    line-height: 42px;
  }

  @media ${MOBILE} {
    font-size: 22px;
    line-height: 30px;
  }
`;

export const H3Styles = css`
  font-weight: 700;
  font-size: 30px;
  line-height: 40px;

  @media ${TABLET} {
    font-size: 26px;
    line-height: 35px;
  }

  @media ${MOBILE} {
    font-size: 21px;
    line-height: 28px;
  }
`;

export const H4Styles = css`
  font-weight: 700;
  font-size: 22px;
  line-height: 30px;

  @media ${TABLET} {
    font-size: 20px;
    line-height: 28px;
  }

  @media ${MOBILE} {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const H5Styles = css`
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;

  @media ${TABLET} {
    font-size: 18px;
    line-height: 26px;
  }

  @media ${MOBILE} {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const H6Styles = css`
  font-weight: 700;
  line-height: 24px;

  @media ${FROM_TABLET} {
    font-size: 16px;
  }

  @media ${MOBILE} {
    font-size: 14px;
  }
`;

export const ParagraphStyles = css`
  @media ${FROM_TABLET} {
    font-size: 16px;
    line-height: 28px;
  }

  @media ${MOBILE} {
    font-size: 15px;
    line-height: 24px;
  }
`;

export const SmallParagraphStyles = css`
  font-size: 14px;
  line-height: 24px;
`;

export const WarningStyles = css`
  font-size: 12px;
  line-height: 16px;
`;

export const ButtonStyles = css`
  cursor: pointer;
  background: #00a3e6;
  border-radius: 10px;
  color: #ffffff;
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  padding: 16px;
  transition: 0.3s all;

  &:hover {
    transform: scale(1.07);
  }
`;

export const FormWrapperStyles = css`
  background: #fff;
  box-shadow: 0px 4px 10px rgba(0,0,0,0.25);
  border-radius: 10px;
  z-index: 10;
  max-width: 368px;

  @media ${TABLET} {
    background: transparent;
    max-width: 560px;
    margin: 0 auto;
    border: none;
    box-shadow: none;
  }

  @media ${MOBILE} {
    background: transparent;
    max-width: 560px;
    margin: 0 auto;
    border: none;
    box-shadow: none;
  }
`;
